import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/categories`;

export const categories = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: API_HOMES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getById: async ({ id }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_HOMES,
      headers: { [X_API_VERSION]: API_VERSION },
      method: "post",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_HOMES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  getFilters: async () => {
    const options = await apiOptions({
      url: `${HOME_SERVICE}/category-filters`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
    });
    return apiRequest(options);
  },
  drops: {
    getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/drops`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
        signal,
        params,
        filters,
        sort,
        top,
        skip,
      });
      return apiRequest(options);
    },
    getById: async ({ categoryId, sort }) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${categoryId}/drops`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
        sort,
      });
      return apiRequest(options);
    },
    create: async ({ categoryId, data, toastMessageConfig } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${categoryId}/drops`,
        method: "post",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
    update: async ({ categoryId, dropId, data, toastMessageConfig }) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${categoryId}/drops/${dropId}`,
        method: "patch",
        headers: { [X_API_VERSION]: API_VERSION },
        data,
      });
      return apiRequest(options, toastMessageConfig);
    },
    delete: async ({ categoryId, dropId, data, toastMessageConfig } = {}) => {
      const options = await apiOptions({
        url: `${API_HOMES}/${categoryId}/drops/${dropId}`,
        method: "delete",
        data,
        headers: { [X_API_VERSION]: API_VERSION },
      });
      return apiRequest(options, toastMessageConfig);
    },
  },
};
